import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import services from "../../api/services";
import { MetaTags } from "react-meta-tags";
import { getRestaurant } from "../../utils/commons";

function useQuery() {
	const { search } = useLocation();

	return React.useMemo(() => new URLSearchParams(search), [search]);
}
const restaurant = getRestaurant();

const VerifyPayment = (props) => {
	let query = useQuery();
	let transactionId = null;
	// const basket = useSelector((state) => state.basket)

	useEffect(() => {
		if (query.get("transactionId")) {
			transactionId = query.get("transactionId");
			setTimeout(() => validatePayment(transactionId), 1000);
		}
	}, []);

	const validatePayment = (transactionId) => {
		return services.checkPayment(
			{ transactionId, noHtml: 1 },
			(res) => {
				if (res.status === "SUCCEEDED") {
					window.location = "/success";
				} else if (res.status === "FAILED") {
					window.location = "/checkout?paymentFailed=1";
				} else {
					setTimeout(() => validatePayment(transactionId), 1000);
				}
			},
			(err) => {
				// console.warn("payinWithMangopay err", err);
			}
		);
	};

	return (
		<div className="verify-payment-container">
			<MetaTags>
				<title>{restaurant.name} | Validation du paiement</title>
				<meta name="description" content="#" />
			</MetaTags>
			<h1>Validation de Paiement en Cours</h1>
			<p>Veuillez patienter pendant que nous validons votre paiement...</p>
			<div className="ct-preloader-inner">
				<div className="lds-ripple">
					<div />
					<div />
				</div>
			</div>
		</div>
	);
};

export default VerifyPayment;
